module.exports = __webpack_public_path__ + "static/media/close-icon.ced15d6a.svg";